export const actionTypes = {
  SECTIONS_REQUEST: "SECTIONS_REQUEST",
  SECTIONS_REQUEST_SUCCESS: "SECTIONS_REQUEST_SUCCESS",
  SECTIONS_REQUEST_FAILURE: "SECTIONS_REQUEST_FAILURE",
  CREATE_SECTION: "CREATE_SECTION",
  CREATE_SECTION_SUCCESS: "CREATE_SECTION_SUCCESS",
  CREATE_SECTION_FAILURE: "CREATE_SECTION_FAILURE",
  EDIT_SECTION: "EDIT_SECTION",
  EDIT_SECTION_SUCCESS: "EDIT_SECTION_SUCCESS",
  EDIT_SECTION_FAILURE: "EDIT_SECTION_FAILURE",
  DELETE_SECTION: "DELETE_SECTION",
  DELETE_SECTION_SUCCESS: "DELETE_SECTION_SUCCESS",
  DELETE_SECTION_FAILURE: "DELETE_SECTION_FAILURE",
  SAVE_ATTACHMENT_IN_SECTION: "SAVE_ATTACHMENT_IN_SECTION",
  SAVE_ATTACHMENT_IN_SECTION_SUCCESS: "SAVE_ATTACHMENT_IN_SECTION_SUCCESS",
  SAVE_ATTACHMENT_IN_SECTION_FAILURE: "SAVE_ATTACHMENT_IN_SECTION_FAILURE",
  DELETE_ATTACHMENT_FROM_SECTION: "DELETE_ATTACHMENT_FROM_SECTION",
  DELETE_ATTACHMENT_FROM_SECTION_SUCCESS:
    "DELETE_ATTACHMENT_FROM_SECTION_SUCCESS",
  DELETE_ATTACHMENT_FROM_SECTION_FAILURE:
    "DELETE_ATTACHMENT_FROM_SECTION_FAILURE",
  SECTION_DETAIL_REQUEST: "SECTION_DETAIL_REQUEST",
  SECTION_DETAIL_GET_ATTACHMENTS_REQUEST:
    "SECTION_DETAIL_GET_ATTACHMENTS_REQUEST",
  SECTION_DETAIL_GET_ATTACHMENTS_REQUEST_SUCCESS:
    "SECTION_DETAIL_GET_ATTACHMENTS_REQUEST_SUCCESS",
  SECTION_DETAIL_GET_ATTACHMENTS_REQUEST_FAILURE:
    "SECTION_DETAIL_GET_ATTACHMENTS_REQUEST_FAILURE",
  RESET_SECTION_DETAIL: "RESET_SECTION_DETAIL",
  GET_ROLE_IN_ATTACHMENT_REQUEST: "GET_ROLE_IN_ATTACHMENT_REQUEST",
  GET_ROLE_IN_ATTACHMENT_REQUEST_SUCCESS:
    "GET_ROLE_IN_ATTACHMENT_REQUEST_SUCCESS",
  GET_ROLE_IN_ATTACHMENT_REQUEST_FAILURE:
    "GET_ROLE_IN_ATTACHMENT_REQUEST_FAILURE",
  GET_ATTACHMENT_INFO: "GET_ATTACHMENT_INFO",
  RESET_ATTACHMENT_INFO: "RESET_ATTACHMENT_INFO",
  MODIFY_SELECTED_ROLES: "MODIFY_SELECTED_ROLES",
  RESET_STATE_MANUALS_MANAGEMENT: "RESET_STATE_MANUALS_MANAGEMENT",
  GET_ALL_ROLES: "GET_ALL_ROLES",
  GET_ALL_ROLES_SUCCESS: "GET_ALL_ROLES_SUCCESS",
  GET_ALL_ROLES_FAILURE: "GET_ALL_ROLES_FAILURE",
  SET_SELECTED_ROLE: "SET_SELECTED_ROLE",
  ADD_SELECTED_ROLES: "ADD_SELECTED_ROLES",
  MODIFY_TOTAL_ROLES: "MODIFY_TOTAL_ROLES",
  REMOVE_SELECTED_ROLES: "REMOVE_SELECTED_ROLES",
  UPDATE_ROLES_IN_ATTACHMENT: "UPDATE_ROLES_IN_ATTACHMENT",
  UPDATE_ROLES_IN_ATTACHMENT_SUCCESS: "UPDATE_ROLES_IN_ATTACHMENT_SUCCESS",
  UPDATE_ROLES_IN_ATTACHMENT_FAILURE: "UPDATE_ROLES_IN_ATTACHMENT_FAILURE",
};

export const updateRolesInAttachment = (id: string, payload: any[]) => ({
  type: actionTypes.UPDATE_ROLES_IN_ATTACHMENT,
  id,
  payload,
});

export const updateRolesInAttachmentSuccess = (payload: any[]) => ({
  type: actionTypes.UPDATE_ROLES_IN_ATTACHMENT_SUCCESS,
  payload,
});

export const updateRolesInAttachmentFailure = (err: Error) => ({
  type: actionTypes.UPDATE_ROLES_IN_ATTACHMENT_FAILURE,
  err,
});

export const addSelectedRoles = (payload: any) => ({
  type: actionTypes.ADD_SELECTED_ROLES,
  payload,
});

export const removeSelectedRoles = (payload: any) => ({
  type: actionTypes.REMOVE_SELECTED_ROLES,
  payload,
});

export const modifyTotalRoles = (payload: any[]) => ({
  type: actionTypes.MODIFY_TOTAL_ROLES,
  payload,
});

export const setSelectedRole = (payload: any[]) => ({
  type: actionTypes.SET_SELECTED_ROLE,
  payload,
});

export const getAllRoles = () => ({
  type: actionTypes.GET_ALL_ROLES,
});

export const getAllRolesSuccess = (payload: any[]) => ({
  type: actionTypes.GET_ALL_ROLES_SUCCESS,
  payload,
});

export const getAllRolesFailure = (err: Error) => ({
  type: actionTypes.GET_ALL_ROLES_FAILURE,
  err,
});

export const sectionsRequest = () => ({
  type: actionTypes.SECTIONS_REQUEST,
});

export const sectionsRequestSuccess = (payload: string[]) => ({
  type: actionTypes.SECTIONS_REQUEST_SUCCESS,
  payload,
});

export const sectionsRequestFailure = (err: Error) => ({
  type: actionTypes.SECTIONS_REQUEST_FAILURE,
  err,
});

export const createSection = (payload: any[]) => ({
  type: actionTypes.CREATE_SECTION,
  payload,
});

export const createSectionSuccess = (payload: any) => ({
  type: actionTypes.CREATE_SECTION_SUCCESS,
  payload,
});

export const createSectionFailure = (err: Error) => ({
  type: actionTypes.CREATE_SECTION_FAILURE,
  err,
});

export const sectionDetailRequest = (payload: any) => ({
  type: actionTypes.SECTION_DETAIL_REQUEST,
  payload,
});

export const getAttachmentsRequest = (payload: any) => ({
  type: actionTypes.SECTION_DETAIL_GET_ATTACHMENTS_REQUEST,
  payload,
});

export const getAttachmentsRequestSuccess = (payload: any) => ({
  type: actionTypes.SECTION_DETAIL_GET_ATTACHMENTS_REQUEST_SUCCESS,
  payload,
});

export const getAttachmentsRequestFailure = (err: Error) => ({
  type: actionTypes.SECTION_DETAIL_GET_ATTACHMENTS_REQUEST_FAILURE,
  err,
});

export const editSection = (payload: any[]) => ({
  type: actionTypes.EDIT_SECTION,
  payload,
});

export const editSectionSuccess = (payload: any) => ({
  type: actionTypes.EDIT_SECTION_SUCCESS,
  payload,
});

export const editSectionFailure = (err: Error) => ({
  type: actionTypes.EDIT_SECTION_FAILURE,
  err,
});

export const resetSectionDetail = () => ({
  type: actionTypes.RESET_SECTION_DETAIL,
});

export const getRoleInAttachmentRequest = (payload: any) => ({
  type: actionTypes.GET_ROLE_IN_ATTACHMENT_REQUEST,
  payload,
});

export const getRoleInAttachmentRequestSuccess = (payload: any) => ({
  type: actionTypes.GET_ROLE_IN_ATTACHMENT_REQUEST_SUCCESS,
  payload,
});

export const getRoleInAttachmentRequestFailure = (err: Error) => ({
  type: actionTypes.GET_ROLE_IN_ATTACHMENT_REQUEST_FAILURE,
  err,
});

export const getAttachmentInfo = (payload: any) => ({
  type: actionTypes.GET_ATTACHMENT_INFO,
  payload,
});

export const modifySelectedRoles = (payload: any[]) => ({
  type: actionTypes.MODIFY_SELECTED_ROLES,
  payload,
});

export const resetAttachmentInfo = () => ({
  type: actionTypes.RESET_ATTACHMENT_INFO,
});

export const deleteSection = (payload: any[]) => ({
  type: actionTypes.DELETE_SECTION,
  payload,
});

export const deleteSectionSuccess = (payload: any) => ({
  type: actionTypes.DELETE_SECTION_SUCCESS,
  payload,
});

export const deleteSectionFailure = (err: Error) => ({
  type: actionTypes.DELETE_SECTION_FAILURE,
  err,
});

export const deleteAttachmentFromSection = (payload: any) => ({
  type: actionTypes.DELETE_ATTACHMENT_FROM_SECTION,
  payload,
});

export const deleteAttachmentFromSectionSuccess = (payload: any) => ({
  type: actionTypes.DELETE_ATTACHMENT_FROM_SECTION_SUCCESS,
  payload,
});

export const deleteAttachmentFromSectionFailure = (err: Error) => ({
  type: actionTypes.DELETE_ATTACHMENT_FROM_SECTION_FAILURE,
  err,
});

export const saveAttachmentInSection = (payload: FormData) => ({
  type: actionTypes.SAVE_ATTACHMENT_IN_SECTION,
  payload,
});

export const saveAttachmentInSectionSuccess = (payload: any) => ({
  type: actionTypes.SAVE_ATTACHMENT_IN_SECTION_SUCCESS,
  payload,
});

export const saveAttachmentInSectionFailure = (err: Error) => ({
  type: actionTypes.SAVE_ATTACHMENT_IN_SECTION_FAILURE,
  err,
});

export const resetState = () => ({
  type: actionTypes.RESET_STATE_MANUALS_MANAGEMENT,
});
